import * as Sentry from '@sentry/react';

import { unwrap } from '@/services/agents/config';
import { apiRequest } from '@/utils/api-request';

export type AgentRunLifecycleAction = 'pause' | 'resume' | 'stop';

export interface AgentRunLifecycleResponse {
  status: string;
  agent_id: string;
  run_id: string;
  workflow_id?: string;
  session_id?: string;
  was_already_completed?: boolean;
}

export async function signalAgentRunLifecycle(
  orgId: string,
  agentId: string,
  runId: string,
  action: AgentRunLifecycleAction,
): Promise<AgentRunLifecycleResponse> {
  const response = await apiRequest<AgentRunLifecycleResponse>({
    url: `/agents/${encodeURIComponent(orgId)}/${encodeURIComponent(agentId)}/runs/${encodeURIComponent(runId)}/${action}`,
    method: 'POST',
    target: 'platform',
    body: {},
  });

  try {
    return unwrap<AgentRunLifecycleResponse>(
      response,
    ) as AgentRunLifecycleResponse;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        context: 'signal-agent-run-lifecycle',
        orgId,
        agentId,
        runId,
        action,
      },
    });
    throw error;
  }
}
